export class TaxScheme {
    taxSchemeId: number;
    tempId: number;
    rate: string;
    taxSchemeCode: string;
    resourceType: string;
    special: boolean;
    exempt: boolean;
}
